import React from 'react'
import { ListItem, ListItemButton, ListItemText, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useUserRole } from '@/hooks/useUserRole'
import { hasSupportAccess } from '@/utils/roleUtils'

interface NavigationItem {
    key: string
    path: string
    label: string
    isResume?: boolean
}

interface NavigationListItemsProps {
    user: { id: string } | null
    navigationItems: NavigationItem[]
    authItems: NavigationItem[]
    isActive: (path: string) => boolean
    onNavigation: (path: string) => void
    onLogout: () => void
}

export const NavigationListItems: React.FC<NavigationListItemsProps> = ({
    user,
    navigationItems,
    authItems,
    isActive,
    onNavigation,
    onLogout,
}) => {
    const { t } = useTranslation()
    const { role } = useUserRole()
    const showAdmin = hasSupportAccess(role)

    if (user) {
        return (
            <>
                {navigationItems.map((item) => (
                    <ListItem key={item.key} disablePadding>
                        <ListItemButton
                            onClick={() => onNavigation(item.path)}
                            selected={isActive(item.path)}
                            aria-current={isActive(item.path) ? 'page' : undefined}
                            sx={{
                                fontWeight: 400,
                            }}
                        >
                            <ListItemText primary={item.label} />
                        </ListItemButton>
                    </ListItem>
                ))}
                <Divider sx={{ my: 1 }} />
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            onNavigation('/profile')
                        }}
                        aria-label={t('navigation:profile')}
                    >
                        <ListItemText primary={t('navigation:profile')} />
                    </ListItemButton>
                </ListItem>
                {showAdmin && (
                    <ListItem disablePadding>
                        <ListItemButton
                            onClick={() => {
                                onNavigation('/admin')
                            }}
                            aria-label={t('navigation:admin')}
                        >
                            <ListItemText primary={t('navigation:admin')} />
                        </ListItemButton>
                    </ListItem>
                )}
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            onNavigation('/privacy')
                        }}
                        aria-label={t('privacy:legal.privacy')}
                    >
                        <ListItemText primary={t('privacy:legal.privacy')} />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton onClick={onLogout} aria-label={t('navigation:logout')}>
                        <ListItemText primary={t('navigation:logout')} />
                    </ListItemButton>
                </ListItem>
            </>
        )
    }

    return (
        <>
            {authItems.map((item) => (
                <ListItem key={item.key} disablePadding>
                    <ListItemButton
                        onClick={() => onNavigation(item.path)}
                        selected={isActive(item.path)}
                        aria-current={isActive(item.path) ? 'page' : undefined}
                    >
                        <ListItemText primary={item.label} />
                    </ListItemButton>
                </ListItem>
            ))}
            <Divider sx={{ my: 1 }} />
            <ListItem disablePadding>
                <ListItemButton
                    onClick={() => {
                        onNavigation('/privacy')
                    }}
                    aria-label={t('privacy:legal.privacy')}
                >
                    <ListItemText primary={t('privacy:legal.privacy')} />
                </ListItemButton>
            </ListItem>
        </>
    )
}
